const Roles = [
    {label: "All", value: "All"},
    {label: "System Administrator", value: "System Administrator", permissions: []},
    {label: "Application Officer", value: "Application Officer", permissions: []},
    {label: "Monitoring Officer", value: "Monitoring Officer", permissions: []},
]

export default Roles;